import httpAuth from "@/common/http-common";
import { SurveyResult, AlertZone } from "@/views/sidebar/survey/survey.types";

class SurveyService {
  async getSurveyAnswers(clientId: number, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<SurveyResult[]>(
      '/Notification/GetSurveyAnswers', { params: { 
        clientId: clientId,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async getAlertZones(alertZoneType: number, clientId: number) {
    const { data } = await httpAuth().get<AlertZone[]>(
      '/Dashboard/GetAlertZones', { params: { 
        alertZoneType: alertZoneType,
        clientId: clientId
      } 
    });
    return data;
  }
}

export default new SurveyService();